<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-10 21:19:08
 * @LastEditTime: 2020-09-27 09:59:18
 * @Description: 添加编辑储罐借用抽屉
-->
<template>
  <Drawer
    width="800"
    :title="`${openedTankRental ? '编辑' : '新增'}储罐借用`"
    v-model="drawerOpened"
  >
    <Form
      @submit.native.prevent
      ref="formItem"
      :model="formItem"
      :rules="ruleValidate"
      label-position="top"
    >
      <div class="wrap">
        <div class="addForm">
          <FormItem label="客户" prop="customer">
            <Select
              v-model="formItem.customer"
              style="width: 350px"
              filterable
              :remote-method="remoteMethod"
              :loading="customerLoading"
              placeholder="请填写客户名字后选择"
            >
              <Option
                v-for="customer in customerList"
                :value="customer._id"
                remote
                :key="customer._id"
                style="width: 350px"
                >{{ customer.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="公司" prop="company">
            <Select v-model="formItem.company" style="width: 350px">
              <Option
                v-for="company in companyList"
                :value="company._id"
                :key="company._id"
                style="width: 350px"
                >{{ company.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="合同编号" prop="remark">
            <Input
              v-model="formItem.contractId"
              style="width: 300px"
              placeholder="输入合同编号..."
            />
          </FormItem>
          <FormItem label="合同状态" prop="status">
            <Select v-model="formItem.status" style="width: 300px">
              <Option
                v-for="status in statusList"
                :value="status.value"
                :key="status.value"
                style="width: 300px"
                >{{ status.label }}</Option
              >
            </Select>
          </FormItem>
          <FormItem label="合同开始日期" prop="contractStartedAt">
            <DatePicker
              type="date"
              v-model="formItem.contractStartedAt"
              style="width: 300px"
              placeholder="选择合同开始日期"
            ></DatePicker>
          </FormItem>
          <FormItem label="合同结束日期" prop="contractEndedAt">
            <DatePicker
              type="date"
              v-model="formItem.contractEndedAt"
              style="width: 300px"
              placeholder="选择合同结束日期"
            ></DatePicker>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input
              v-model="formItem.remark"
              style="width: 350px"
              placeholder="输入备注..."
            />
          </FormItem>
          <FormItem label="doc文件" prop="doc">
            <input
              type="file"
              ref="docFilElem"
              @change="getDocFile($event)"
              multiple="multiplt"
              class="add-file-right-input"
              style="display: none"
              accept=".docx,.doc"
            />
            <div
              v-for="(file, index) in docFileList"
              :value="file._id"
              :key="file._id"
            >
              <div class="fileList-item">
                <div class="fileList-item-name">
                  {{ file.fileName ? file.fileName : file.name }}
                </div>
                <div
                  class="fileList-item-down"
                  @click="downFileItem(file)"
                  v-if="openedTankRental"
                >
                  下载
                </div>
                <div class="fileList-item-del" @click="delFileItem(index)">
                  删除
                </div>
              </div>
            </div>
            <Button type="primary" @click="openF('docFilElem')"
              >选择文件</Button
            >
          </FormItem>
          <FormItem label="pdf文件" prop="pdf">
            <input
              type="file"
              ref="pdfFilElem"
              @change="getPdfFile($event)"
              multiple="multiplt"
              class="add-file-right-input"
              style="display: none"
              accept=".pdf"
            />
            <div
              v-for="(file, index) in pdfFileList"
              :value="file._id"
              :key="file._id"
            >
              <div class="fileList-item">
                <div class="fileList-item-name">
                  {{ file.fileName ? file.fileName : file.name }}
                </div>
                <div class="fileList-item-down" v-if="openedTankRental">
                  下载
                </div>
                <div class="fileList-item-del" @click="delFileItem(index)">
                  删除
                </div>
              </div>
            </div>
            <Button type="primary" @click="openF('pdfFilElem')"
              >选择文件</Button
            >
          </FormItem>
          <FormItem>
            <Button type="primary" @click="handleSubmit('formItem')"
              >保存</Button
            >
          </FormItem>
        </div>
        <div class="storagetank">
          <h3>储罐</h3>
          <FormItem prop="storageTank">
            <Select
              style="width: 350px"
              filterable
              v-model="selectedTank"
              @on-change="addTank"
              :remote-method="getStorageTankListMethod"
              :loading="storageTankLoading"
              placeholder="搜索储罐"
            >
              <Option
                v-for="storageTank in storageTankList"
                :value="storageTank._id"
                :label="storageTank.name"
                remote
                :key="storageTank._id"
                style="
                  width: 350px;
                  display: flex;
                  justify-content: space-between;
                "
                ><div>{{ storageTank.name }}</div>
                <div>添加</div></Option
              >
            </Select>
          </FormItem>
          <div class="table-wrapper" ref="tableWrapper">
            <Table :columns="columns" :data="tankTable" :height="tableHeight">
              <template
                slot-scope="{ row }"
                slot="deleteBtn"
                style="padding-left: 0"
              >
                <Icon
                  type="ios-remove-circle-outline"
                  class="deleteBtn"
                  @click="removeTank(row._id)"
                /> </template
            ></Table>
          </div>
        </div>
      </div>
    </Form>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AddTankRentalDrawer",
  data() {
    return {
      customerLoading: false,
      storageTankLoading: false,
      drawerOpened: false,
      openedTankRental: null,
      tableHeight: 300,
      formItem: {
        contractStartedAt: null,
        contractEndedAt: null,
        customer: null,
        company: null,
        remark: null,
        status: null,
        tankList: [],
        docFile: null,
        signedPdfFile: null,
      },
      columns: [
        {
          title: "ID",
          key: "id",
          render: (h, params) => {
            return h("span", params.row.NoId);
          },
        },
        {
          title: "储罐名",
          key: "weight",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.name);
          },
        },
        {
          title: " ",
          key: "deleteBtn",
          slot: "deleteBtn",
          align: "left",
          width: 40,
        },
      ],
      ruleValidate: {
        company: [
          {
            required: true,
            message: "公司为必填项",
            trigger: "blur",
          },
        ],
        customer: [
          {
            required: true,
            message: "客户为必填项",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "合同状态为必填项",
            trigger: "blur",
          },
        ],
        contractStartedAt: [
          {
            required: true,
            type: "date",
            message: "合同开始日期为必填项",
            trigger: "change",
          },
        ],
      },
      statusList: [
        {
          value: "created",
          label: "创建",
        },
        {
          value: "activeButNoSign",
          label: "未签署",
        },
        {
          value: "activeAndSigned",
          label: "已签署",
        },
        {
          value: "readyToShipBack",
          label: "准备发货",
        },
        {
          value: "finished",
          label: "已完成",
        },
      ],
      docFileList: [],
      pdfFileList: [],
      selectedTank: [],
      tankTable: [],
    };
  },
  computed: {
    ...mapState({
      customerList: (state) => state.customer.customersSimple,
      companyList: (state) => state.company.companyList,
      storageTankList: (state) => state.storageTank.storageTankList,
    }),
  },
  methods: {
    async remoteMethod(query) {
      if (query !== "") {
        this.customerLoading = true;
        await this.getCustomerList({ name: query });
        this.customerLoading = false;
      }
    },
    async getStorageTankListMethod(name) {
      if (name !== "") {
        this.storageTankLoading = true;
        await this.getStorageTankList({ name });
        this.storageTankLoading = false;
      }
    },
    ...mapActions({
      createTankRental: "tankRental/createTankRentalAction",
      updateTankRental: "tankRental/updateTankRentalAction",
      getCompanyList: "company/getCompanyListAction",
      getCustomerList: "customer/getCustomerSimpleListAction",
      getStorageTankList: "storageTank/getStorageTankListAction",
    }),
    async openDrawer(tankRental) {
      this.drawerOpened = true;
      this.$refs["formItem"].resetFields();
      this.openedTankRental = tankRental;
      this.docFileList = null;
      this.pdfFileList = null;
      if (tankRental) {
        this.formItem.name = this.openedTankRental.name;
        this.formItem.remark = this.openedTankRental.remark;
        this.formItem.contractStartedAt =
          this.openedTankRental.contractStartedAt;
        this.formItem.contractEndedAt = this.openedTankRental.contractEndedAt;
        this.formItem.company = this.openedTankRental.company._id;
        this.formItem.status = this.openedTankRental.status;
        await this.getCustomerList({});
        await this.getStorageTankList({});
        this.docFileList = this.openedTankRental.docFile;
        this.pdfFileList = this.openedTankRental.signedPdfFile;
        this.formItem.customer = this.openedTankRental.customer._id;
      }
    },
    // 上传文件
    getDocFile(e) {
      const file = e.target.files;
      for (let i = 0; i < file.length; i++) {
        this.docFileList.push(file[i]);
      }
    },
    getPdfFile(e) {
      const file = e.target.files;
      for (let i = 0; i < file.length; i++) {
        this.pdfFileList.push(file[i]);
      }
    },
    openF(tag) {
      this.$refs[tag].dispatchEvent(new MouseEvent("click"));
    },
    delFileItem(index) {
      this.docFileList.splice(index, 1);
    },
    downFileItem(file) {
    },
    addTank() {
      const item = this.storageTankList.filter((x) => {
        return x._id === this.selectedTank;
      });
      this.tankTable = this.tankTable.concat(item);
      this.selectedTank = [];
    },
    removeTank(id) {
      this.tankTable = this.tankTable.filter((x) => {
        return x._id !== id;
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedTankRental) {
              await this.updateTankRental({
                id: this.openedTankRental._id,
                data: this.formItem,
              });
            } else {
              if (this.selectedTank.length > 0) {
                this.formItem.tankList = this.selectedTank;
              }
              let formData = new FormData();
              formData.append("data", JSON.stringify(this.formItem));
              this.docFileList.forEach((x) => formData.append("docFile", x));
              this.pdfFileList.forEach((x) =>
                formData.append("signedPdfFile", x)
              );
              await this.createTankRental(formData);
            }
            this.docFileList = [];
            this.pdfFileList = [];
            this.$Message.success("保存成功!");

            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
  mounted() {
    this.getCompanyList({});
    this.getStorageTankList({});
  },
};
</script>

<style scoped lang="stylus">
.wrap
  display flex
  padding 10px 10px 0 20px

  .addForm, .storagetank
    width 360px

.fileList-item
  display flex

  .fileList-item-name
    margin-right 20px

  .fileList-item-del
    color red
    cursor pointer

  .fileList-item-down
    color blue
    cursor pointer
    margin-right 20px
</style>
